import { __spreadArray } from "tslib";
import Keyframes from '../models/Keyframes';
import generateComponentId from '../utils/generateComponentId';
import { joinStringArray } from '../utils/joinStrings';
import css from './css';
export default function keyframes(strings) {
    var interpolations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        interpolations[_i - 1] = arguments[_i];
    }
    /* Warning if you've used keyframes on React Native */
    if (process.env.NODE_ENV !== 'production' &&
        typeof navigator !== 'undefined' &&
        navigator.product === 'ReactNative') {
        console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
    }
    var rules = joinStringArray(css.apply(void 0, __spreadArray([strings], interpolations, false)));
    var name = generateComponentId(rules);
    return new Keyframes(name, rules);
}
//# sourceMappingURL=keyframes.js.map